import SDFormControl from '@/shared/components/SDComponentsNewDesign/SDFormControl/SDFormControl'
import SDSelect from '@/shared/components/SDComponentsNewDesign/SDSelect/SDSelect'
import getError from '@/containers/SubscriptionFormPageNew/getError'
import useAddress from '../../useAddress'

const HotwaterEnergy = () => {
  const { t, updateAddress, hotwaterEnergy, hotwaterOptions, errors } = useAddress()
  const error = getError('hotWaterMode', errors)

  return (
    <SDFormControl plainLabel error={error}>
      <SDSelect
        label={t('subscriptionTools:estimator.hot_water_mode.label')}
        optionsList={hotwaterOptions}
        translationsPath='subscriptionForm:address_module.hotwater_types.'
        newTranslations={true}
        onChangeHandler={params => updateAddress({ hotwaterEnergy: params.option?.id })}
        selectedValue={hotwaterEnergy ? hotwaterEnergy.toString() : ''}
        hasError={!!error}
      />
    </SDFormControl>
  )
}
export default HotwaterEnergy
